module.exports = __webpack_public_path__ + "static/media/loader.466762ba.gif";